import { CreateChartTemplateDataT } from '../../types';
import { IndicatorBaseT } from 'business/definitions';
import { RQAPICallWithData } from 'store/APIClient';
import { useQuery } from '@tanstack/react-query';

export type ChartTemplateT = IndicatorBaseT &
    CreateChartTemplateDataT & {
        key: number;
        createdAT: Date;
    };

export const useGetChartTemplate = (templateKey: number) =>
    useQuery({
        queryKey: ['chart-template', templateKey],

        queryFn: async () => {
            const response = await RQAPICallWithData<ChartTemplateT>({
                endpoint: `support/chart_templates/${templateKey}`,
                method: 'GET',
            });
            return response.content.data;
        },
    });
